var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSmal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "symbol"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg-rectangle",
    d: "M24.3021 0H14.6952C6.85542 0 0.5 6.35587 0.5 14.1962V23.8038C0.5 31.6441 6.85542 38 14.6952 38H24.3021C32.1419 38 38.4973 31.6441 38.4973 23.8038V14.1962C38.4973 6.35587 32.1419 0 24.3021 0Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "content"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8978 10.8569L11.9205 16.8749C10.3106 18.4717 10.3351 21.0756 11.9205 22.6971C13.5064 24.2932 16.0924 24.2932 17.6781 22.6971L21.1644 19.1654L22.3623 17.9808C23.0205 17.3173 24.1189 17.3173 24.7771 17.9808C25.4359 18.668 25.4359 19.7487 24.7771 20.4367L23.5595 21.7541L20.1177 25.1283C19.0685 26.16 17.8 26.848 16.4583 27.1426H13.1405C11.7985 26.848 10.53 26.16 9.48117 25.1283C6.55323 22.1808 6.55323 17.3666 9.48117 14.4182L13.0428 10.8569H17.8978ZM29.5341 13.1656C32.4381 16.0885 32.4381 20.9038 29.5341 23.8513L26.2656 27.1426H21.4109L27.095 21.4193C28.681 19.8222 28.681 17.1936 27.095 15.5976C25.5091 14.0007 22.9231 14.0007 21.338 15.5976L17.8571 18.999L16.5997 20.2895C15.9407 20.9775 14.8969 20.9775 14.2384 20.2895C13.5551 19.6259 13.513 18.4994 14.1717 17.8358L15.043 16.9024L18.8979 13.1656C21.8255 10.218 26.6067 10.218 29.5341 13.1656Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmal);
export default __webpack_public_path__ + "static/media/logo_smal.0a5aa9e28d5a33b96bf6b5b1386e9bfb.svg";
export { ForwardRef as ReactComponent };